import { render, staticRenderFns } from "./ManagersTable.vue?vue&type=template&id=7e80a6d1"
import script from "./ManagersTable.vue?vue&type=script&lang=js"
export * from "./ManagersTable.vue?vue&type=script&lang=js"
import style0 from "./ManagersTable.vue?vue&type=style&index=0&id=7e80a6d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports